/**
 * Which language to open in, in order of how deliberate the signal is.
 *
 * An explicit ?lang= wins over everything, including a stored preference. It
 * used to lose to one, so the parameter was only ever read on a profile that
 * had none: a Dutch ad click opened in English for anyone who had been to the
 * site before, and for the many Dutch visitors whose browser is set to English,
 * because the system fallback below persists on a first visit without the
 * parameter and is never revisited.
 *
 * Kept free of imports so it can be tested without the build's path aliases.
 *
 * @param {object} signals
 * @param {string|null} signals.urlLang     the ?lang= value, if any
 * @param {string|null} signals.storedLang  the persisted preference
 * @param {string|null} signals.systemLang  the browser or device locale
 * @param {string[]} signals.available      supported languages
 * @param {string} [signals.fallback]
 */
export function resolveInitialLanguage ({ urlLang, storedLang, systemLang, available, fallback = 'en' }) {
  const supported = Array.isArray(available) ? available : []

  if (urlLang && supported.includes(urlLang)) {
    return urlLang
  }
  if (storedLang && supported.includes(storedLang)) {
    return storedLang
  }
  if (systemLang && supported.includes(systemLang)) {
    return systemLang
  }

  return fallback
}
